export default "__VITE_ASSET__CMCBiRCG__"